/**
 * @typedef SnackbarEventOptions
 * @property {string} message
 * @property {object} action
 * @property {Function} action.handler
 * @property {string} action.text
 * @property {string} action.icon
 * @property {string} action.color
 * @property {boolean} closeable
 * @property {string} icon
 * @property {number} timeout default 6000
 */

class SnackbarEvent extends CustomEvent {
  /**
   * Cria um novo evento para Snackbar
   * @param {SnackbarEventOptions} options Opções de exibição de Snackbar
   */
  constructor(options) {
    super(SnackbarEvent.EVENT, { detail: options });
  }

  /**
   * Exibe uma mensagem em Snackbar
   * @param {SnackbarEventOptions} options Opções de exibição de Snackbar
   */
  static emit(options) {
    document.dispatchEvent(new SnackbarEvent(options));
  }

  static emitError(error) {
    const message = error?.response?.data?.error?.message ?? error.message ?? error;
    SnackbarEvent.emit({ message, icon: 'mdi-alert-circle-outline' });
  }

  static emitSuccess(message, timeout = null) {
    SnackbarEvent.emit({ message, icon: 'mdi-check-circle-outline', timeout });
  }

  static emitFixedError(message) {
    SnackbarEvent.emit({ message, icon: 'mdi-alert-circle-outline' });
  }

  /**
   * Escuta de eventos de emissão de Snackbar
   * @param {Function} handler Função a ser chamada quando escutar um novo evento
   */
  static on(handler) {
    document.addEventListener(SnackbarEvent.EVENT, handler);
  }

  /**
   * Remove a escuta de emissão de Snackbar
   * @param {Function} handler Função a ser removida da escuta de eventos
   */
  static off(handler) {
    document.removeEventListener(SnackbarEvent.EVENT, handler);
  }
}

SnackbarEvent.EVENT = 'app:snackbar';

export default SnackbarEvent;
